module.exports = __webpack_public_path__ + "static/media/break-icon-disabled.bce2daa8.svg";